import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TractorsHistoryMessagesComponent } from './tractors-history-messages.component';
import {DxDataGridModule, DxScrollViewModule} from 'devextreme-angular';
import {GridTitleModule} from 'shared';



@NgModule({
  declarations: [TractorsHistoryMessagesComponent],
  imports: [
    CommonModule,
    DxDataGridModule,
    GridTitleModule,
    DxScrollViewModule
  ],
  exports: [TractorsHistoryMessagesComponent]
})
export class TractorsHistoryMessagesModule { }
